<div class="error-page-wrapper">
  <div class="error-container">
    <!-- Animated Background Elements -->
    <div class="background-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>

    <!-- Error Content -->
    <div class="error-content">
      <!-- Error Icon -->
      <div class="error-icon-wrapper">
        <i [class]="errorInfo.icon + ' error-icon'"></i>
      </div>

      <!-- Error Code -->
      <div class="error-code">{{ errorInfo.code }}</div>

      <!-- Error Title -->
      <h1 class="error-title">{{ errorInfo.title }}</h1>

      <!-- Error Description -->
      <p class="error-description">{{ errorInfo.description }}</p>

      <!-- Action Buttons -->
      <div class="error-actions">
        <button class="btn btn-primary btn-lg px-5" (click)="goHome()">
          <i class="pi pi-home me-2"></i>
          {{ 'PAGES.HOME.TITLE' | translate }}
        </button>
        <button class="btn btn-outline-primary btn-lg px-5 ms-3" (click)="goBack()">
          <i class="pi pi-arrow-left me-2"></i>
          {{ 'ACTIONS.BACK' | translate }}
        </button>
      </div>

      <!-- Logout Link -->
      @if (errorInfo.code === '401' || errorInfo.code === '403') {
        <div class="logout-section mt-4">
          <a class="logout-link" (click)="logout()">
            <i class="pi pi-sign-out me-2"></i>
            {{ 'ACCOUNT.LOGOUT' | translate }}
          </a>
        </div>
      }
    </div>
  </div>
</div>
